import { RequestTypes } from '../types';
export const microserviceData = new Map([
    [RequestTypes.translations, '/api/language/translate'],
    [RequestTypes.init, '/api/minigame/init'],
    [RequestTypes.settings, '/api/minigame/settings'],
    [RequestTypes.settingsPut, '/api/us/system/config/user'],
    [RequestTypes.updateParams, '/api/minigame/params'],
    [RequestTypes.saveResults, '/api/minigame/results'],
    [RequestTypes.log, '/api/minigame/log'],
    [RequestTypes.saveBetweenResults, '/api/minigame/trainingResults'],
    [RequestTypes.tutorial, '/api/us/tutorial']
]);
//# sourceMappingURL=index.js.map